export const SWAPI_BASE_URL = 'https://swapi.co/api/';



/** WEBPACK FOOTER **
 ** ./src/constants/config.js
 **/